module.exports = __webpack_public_path__ + "static/img/paint.2bdd28a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/paint.png
// module id = trOD
// module chunks = 1